module.exports = __webpack_public_path__ + "static/media/bg1.f8c2f9ce.jpg";